import React, { Fragment, useState, useEffect } from "react";

//https://github.com/mkhstar/suneditor-react
import "suneditor/dist/css/suneditor.min.css";
import dynamic from "next/dynamic";
const SunEditor = dynamic(() => import("suneditor-react"), {
  ssr: false,
});

export const Editor = ({ name, contents, onChange, height, is_small }) => {
  const options = {
    mode: "classic",
    rtl: false,
    katex: "window.katex",
    imageGalleryUrl: "https://api.myunisearch.com/file-manager/all",
    videoFileInput: false,
    tabDisable: false,
    height: height || 400,
    buttonList: is_small
      ? [
          [
            "undo",
            "redo",
            "font",
            "fontSize",
            "formatBlock",
            "blockquote",
            "bold",
            "underline",
            "italic",
            "align",
            "fontColor",
            "list",
            "lineHeight",
          ],
        ]
      : [
          [
            "undo",
            "redo",
            "font",
            "fontSize",
            "formatBlock",
            "paragraphStyle",
            "blockquote",
            "bold",
            "underline",
            "italic",
            "strike",
            "subscript",
            "superscript",
            "fontColor",
            "hiliteColor",
            "textStyle",
            "removeFormat",
            "outdent",
            "indent",
            "align",
            "horizontalRule",
            "list",
            "lineHeight",
            "table",
            "link",
            // "image",
            // "video",
            // "audio",
            // "math",
            "imageGallery",
            "fullScreen",
            "showBlocks",
            "codeView",
            "preview",
            // "print",
            // "save",
            // "template",
          ],
        ],
    "lang(In nodejs)": "en",
  };

  const target_name = name || "description";
  const [editorState, setEditorState] = useState();

  useEffect(() => {
    setEditorState(contents || "");
  }, [contents]);

  const handleChange = (content) => {
    setEditorState(content);
    if (onChange) {
      const target = { name: target_name, value: content };
      onChange({ target });
    }
  };

  return (
    <Fragment>
      <SunEditor
        setOptions={options}
        onChange={handleChange}
        setContents={editorState}
      />
    </Fragment>
  );
};

export default Editor;
